import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import TotalAmountField from "./totalAmountField";

import { VaporDatePicker } from "../../../vapor";

const FormCompensa = props => {
  const { selectedRows, deadlineDate, setDeadlineDate } = props;

  const deadlineDateCompensation = useIntl().formatMessage({
    id: "deadlines.merge.deadlineDateCompensation"
  });
  const genericDescription = useIntl().formatMessage({ id: "generic.description" });
  const amountText = useIntl().formatMessage({ id: "deadlines.amount" });
  const deadlineStatusText = useIntl().formatMessage({ id: "deadlines.deadlineStatus" });

  let finalAmount = 0;
  let rows = [];

  selectedRows.map(element => {
    if (element) {
            
      finalAmount += element.amount;
      rows.push(<div className={"deadlinesDialogMerge-table1-row"}>
        <div className={"deadlinesDialogMerge-table1-col col1"}>
          {typeof element.description === "string" ? element.description : element.description.title} {element.description.details}
        </div>
        <div
          className={"deadlinesDialogMerge-table1-col col2"}
          style={{ textAlign: "right" }}
        >
          {<TotalAmountField totalAmount={element.amount} />}
        </div>
        <div
          className={"deadlinesDialogMerge-table1-col col3"}
          style={{ color: "#9da6ad", textDecoration: "line-through" }}
        >
          {element.payment.type === "item_pays" ? (
            <FormattedMessage id={"deadlines.pages.table.due"} />
          ) : (
            <FormattedMessage id={"deadlines.pages.table.toCash"} />
          )}
        </div>
      </div>);
    }

    return rows;
  });

  if (finalAmount !== 0) {
    rows.push(<div className={"deadlinesDialogMerge-table1-row"}>
      <div className={"deadlinesDialogMerge-table1-col col1"}>
          "Nuova scadenza"
      </div>
      <div
        className={"deadlinesDialogMerge-table1-col col2"}
        style={{ textAlign: "right" }}
      >
        {<TotalAmountField totalAmount={finalAmount} />}
      </div>
      <div className={"deadlinesDialogMerge-table1-col col3"}>
        {finalAmount < 0 ? (
          <FormattedMessage id={"deadlines.pages.table.due"} />
        ) : finalAmount > 0 ? (
          <FormattedMessage id={"deadlines.pages.table.toCash"} />
        ) : null}
      </div>
    </div>);
  }

  return (
    <div>
      <section className={"deadlinesDialogMerge-form2"}>
        <div className={"deadlinesDialogMerge-form2-row row2"}>
          <div className={"deadlinesDialogMerge-form2-date"}>
            <span>
              {deadlineDateCompensation}{" "}
              *
            </span>
            <VaporDatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              className={"deadlinesDialogMerge-form2-dateWidget"}
              value={deadlineDate}
              onChange={value => {
                setDeadlineDate(value);
              }}
            />
          </div>
        </div>
      </section>
      <section className={"deadlinesDialogMerge-table1"}>
        <header className={"deadlinesDialogMerge-table1-header"}>
          <div className={"deadlinesDialogMerge-table1-col col1"}>
            {genericDescription}
          </div>
          <div
            className={"deadlinesDialogMerge-table1-col  col2"}
            style={{ textAlign: "right" }}
          >
            {amountText}
          </div>
          <div className={"deadlinesDialogMerge-table1-col col3"}>
            {deadlineStatusText}
          </div>
        </header>
        {rows}
      </section>
    </div>
  );
};

export default FormCompensa;
